module.exports = __webpack_public_path__ + "static/media/monitor-button3.0f191e41.png";